export default function ({ app }) {
  const stored = localStorage.getItem('dark-mode');
  if (stored !== null) {
    app.vuetify.framework.theme.dark = stored === 'true';
  }
}
